import { createContext, useContext, useEffect, useState } from "react";
import type { ReactNode } from "react";
import { sistema } from "@plantus/api-client";

/**
 * Qual ambiente está no ar — e, portanto, se a faixa aparece.
 *
 * <p>Vem de `GET /api/versao`, que é público. O valor **não** é adivinhado
 * pelo domínio: errar isso faria um sistema não validado se passar por
 * validado, e URL é fácil demais de confundir.
 *
 * <p>Enquanto a resposta não chega, o ambiente é `null` — e a
 * `FaixaAmbiente` trata `null` como desconhecido, exibindo o aviso. Na
 * dúvida, avisa.
 */
interface Ambiente {
  ambiente: string | null;
  versao: string | null;
  commit: string | null;
}

const Contexto = createContext<Ambiente>({ ambiente: null, versao: null, commit: null });

export function ProvedorDeAmbiente({ children }: { children: ReactNode }) {
  const [estado, definir] = useState<Ambiente>({ ambiente: null, versao: null, commit: null });

  useEffect(() => {
    let ativo = true;
    sistema
      .versao()
      .then((v) => {
        if (ativo) {
          definir({ ambiente: v.ambiente, versao: v.versao, commit: v.commit });
        }
      })
      .catch(() => {
        // Sem resposta, o ambiente segue desconhecido — e a faixa aparece.
      });
    return () => {
      ativo = false;
    };
  }, []);

  return <Contexto.Provider value={estado}>{children}</Contexto.Provider>;
}

export function usarAmbiente(): Ambiente {
  return useContext(Contexto);
}
